import { CheckCircle, XCircle, Circle } from 'lucide-react';

const passwordRequirements = [
  {
    id: 'min',
    label: 'Contain at least 12 characters',
    errorType: 'too_small',
  },
  {
    id: 'number',
    label: 'Contain at least one number',
    errorType: 'invalid_string',
    regex: /\d/,
  },
  {
    id: 'special',
    label: 'Contain at least one special character',
    errorType: 'invalid_string',
    regex: /[!@#$%^&*(),.?":{}|<>]/,
  },
];

export type PasswordRequirementsSectionProps = {
  password: string;
};

export const PasswordRequirementsSection = ({
  password,
}: PasswordRequirementsSectionProps) => {
  const passwordEntered = password && password.length > 0;
  return (
    <div className="mt-2 space-y-1">
      <p className="text-sm text-gray-600">Password requirements:</p>
      <ul className="space-y-1">
        {passwordRequirements.map((req, index) => {
          let isMatched = false;
          let isUnmatched = false;

          if (passwordEntered) {
            // Direct validation for each requirement
            const hasMinLength = password.length >= 12;
            const hasNumber = /\d/.test(password);
            const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

            if (req.id === 'min') {
              isMatched = hasMinLength;
              isUnmatched = !hasMinLength;
            } else if (req.id === 'number') {
              isMatched = hasNumber;
              isUnmatched = !hasNumber;
            } else if (req.id === 'special') {
              isMatched = hasSpecialChar;
              isUnmatched = !hasSpecialChar;
            }
          }

          return (
            <li key={index} className="flex items-center text-sm">
              <div className="flex h-4 w-4 items-center justify-center">
                {isMatched && (
                  <CheckCircle
                    className="h-4 w-4 text-green-500"
                    data-testid="check-circle-icon"
                  />
                )}
                {isUnmatched && (
                  <XCircle
                    className="h-4 w-4 text-red-500"
                    data-testid="x-circle-icon"
                  />
                )}
                {!passwordEntered && (
                  <Circle
                    className="h-4 w-4 text-gray-300"
                    data-testid="circle-icon"
                  />
                )}
              </div>
              <span
                className={`ml-2 ${
                  isMatched
                    ? 'text-green-500'
                    : isUnmatched
                      ? 'text-red-500'
                      : 'text-gray-600'
                }`}
              >
                {req.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
